import React from "react";
import Swal from "sweetalert2";
import userService from "../../services/user.service";

const DeleteUser = (props: any) => {
  const { user } = props;
  const onDelete = () => {
    Swal.fire({
      title: "คุณต้องการลบ?",
      text: `ผู้ใช้ (${user.username}) ${user.firstName} ${user.lastName}  !`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log("ใช้ต้องการลบเดียวนี้");
        userService
          .deletecUser(user.id)
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(() => {
            Swal.fire({
              position: "center",
              icon: "error",
              title:
                "ตรวจสอบว่ายังมีรายวิชาอยู่ในหลักสูตรนี้หรือไม่ ถ้ามีต้องลบก่อนครับ",
              showConfirmButton: true,
            });
          });
      }
    });
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-danger text-white ms-1"
        onClick={onDelete}
      >
        <i className="bi bi-trash3"></i> ลบ
      </button>
    </>
  );
};

export default DeleteUser;
